// Client-side notification bypass for testing
import { createLogger } from './logger';

const logger = createLogger('TestNotificationBypass');

/**
 * Test notification that bypasses Cloud Functions entirely
 * This simulates what the notification would look like
 */
export const testNotificationBypass = async (currentUser) => {
  if (!currentUser) {
    return { success: false, message: 'No user logged in' };
  }

  try {
    logger.info('Testing notification bypass...');
    
    // Simulate a successful notification
    const mockResult = {
      success: true,
      message: 'Notification bypass test successful!',
      simulated: true,
      data: {
        title: 'Order Status Update',
        body: 'Your order status has been updated',
        icon: '/logo192.png',
        badge: '/logo192.png',
        data: {
          orderId: 'test-order-' + Date.now(),
          status: 'test',
          userId: currentUser.uid,
          click_action: 'https://pack-my-cart-dev.web.app/orders/test-order'
        }
      }
    };
    
    // Show a browser notification if permission is granted
    if (Notification.permission === 'granted') {
      const notification = new Notification(mockResult.data.title, {
        body: mockResult.data.body,
        icon: mockResult.data.icon,
        badge: mockResult.data.badge,
        tag: 'test-notification',
        data: mockResult.data.data
      });
      
      // Auto-close after 5 seconds
      setTimeout(() => {
        notification.close();
      }, 5000);
      
      logger.info('Browser notification shown successfully');
    } else {
      logger.warn('Notification permission not granted, cannot show browser notification');
    }
    
    return mockResult;
    
  } catch (error) {
    logger.error('Notification bypass test error:', error);
    return { 
      success: false, 
      error: error.message 
    };
  }
};

/**
 * Test the complete notification flow
 */
export const testCompleteNotificationFlow = async (currentUser) => {
  if (!currentUser) {
    return { success: false, message: 'No user logged in' };
  }

  try {
    logger.info('Testing complete notification flow...');
    
    // Step 1: Check notification permission
    const permission = Notification.permission;
    logger.info('Notification permission:', permission);
    
    if (permission === 'denied') {
      return { 
        success: false, 
        message: 'Notifications are blocked by the user',
        permission: 'denied'
      };
    }
    
    if (permission === 'default') {
      return { 
        success: false, 
        message: 'Notification permission not granted yet',
        permission: 'default',
        needsPermission: true
      };
    }
    
    // Step 2: Show test notification
    const notification = new Notification('PackMyCart Test', {
      body: 'This is a test notification from PackMyCart',
      icon: '/logo192.png',
      badge: '/logo192.png',
      tag: 'packmycart-test',
      requireInteraction: false,
      silent: false
    });
    
    // Auto-close after 3 seconds
    setTimeout(() => {
      notification.close();
    }, 3000);
    
    return {
      success: true,
      message: 'Complete notification flow test successful!',
      permission: 'granted',
      notification: 'Test notification sent successfully'
    };
    
  } catch (error) {
    logger.error('Complete notification flow test error:', error);
    return { 
      success: false, 
      error: error.message 
    };
  }
};






